function requiredFunction(value, label) {
  if (typeof value !== "function") {
    throw new TypeError(`${label} must be a function`);
  }
  return value;
}

export function createCalculatorScenarioCommitter({
  commit,
  requestFrame,
  cancelFrame,
  scheduleTask,
  cancelTask,
  pageLifecycle = null,
}) {
  const commitPending = requiredFunction(commit, "Calculator scenario commit");
  const requestPaintFrame = requiredFunction(
    requestFrame,
    "Calculator scenario frame scheduler",
  );
  const cancelPaintFrame = requiredFunction(
    cancelFrame,
    "Calculator scenario frame cancellation",
  );
  const scheduleAfterPaintTask = requiredFunction(
    scheduleTask,
    "Calculator scenario task scheduler",
  );
  const cancelAfterPaintTask = requiredFunction(
    cancelTask,
    "Calculator scenario task cancellation",
  );
  let pendingSignals = null;
  let frameId = null;
  let taskId = null;
  let disposed = false;

  function commitNow() {
    if (pendingSignals === null) {
      return false;
    }
    const signals = pendingSignals;
    pendingSignals = null;
    commitPending(signals);
    return true;
  }

  function runTask() {
    taskId = null;
    commitNow();
  }

  function scheduleTaskAfterPaint() {
    frameId = null;
    if (pendingSignals === null || taskId !== null || disposed) {
      return;
    }
    taskId = scheduleAfterPaintTask(runTask, 0);
  }

  function schedule(signals) {
    if (disposed) {
      return false;
    }
    pendingSignals = signals;
    if (frameId === null && taskId === null) {
      frameId = requestPaintFrame(scheduleTaskAfterPaint);
    }
    return true;
  }

  function flush() {
    if (frameId !== null) {
      cancelPaintFrame(frameId);
      frameId = null;
    }
    if (taskId !== null) {
      cancelAfterPaintTask(taskId);
      taskId = null;
    }
    return commitNow();
  }

  function dispose() {
    flush();
    disposed = true;
    pageLifecycle?.removeEventListener?.("pagehide", flush);
  }

  pageLifecycle?.addEventListener?.("pagehide", flush);

  return Object.freeze({
    dispose,
    flush,
    schedule,
  });
}
